import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { AspectPicker } from "@/components/create/AspectPicker";
import { api } from "@/lib/api";
import { formatNumber } from "@/lib/format";

export function VideoForm({ offer }) {
  const qc = useQueryClient();
  const [prompt, setPrompt] = useState("");
  const [aspect, setAspect] = useState("16:9");
  const create = useMutation({
    mutationFn: () => api.post("/media/generations", { kind: "video", prompt: prompt.trim(), aspect_ratio: aspect }),
    onSuccess: () => {
      setPrompt("");
      ["media-generations", "me"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
    },
    onError: (e) => toast.error(e.message),
  });
  return (
    <div className="space-y-4 rounded-2xl border border-white/[0.08] bg-ink-850 p-4 sm:p-5" data-testid="video-form">
      <textarea value={prompt} onChange={(e) => setPrompt(e.target.value)} maxLength={2000} rows={3} data-testid="video-prompt-input"
        placeholder="Describe the scene and the camera movement…"
        className="w-full resize-none rounded-xl border border-white/10 bg-ink-900 p-3 text-sm text-zinc-100 placeholder:text-zinc-600 focus:border-white/25 focus:outline-none" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <AspectPicker options={offer?.aspect_ratios || []} value={aspect} onChange={setAspect} />
        <button type="button" disabled={!offer?.available || !prompt.trim() || create.isPending} onClick={() => create.mutate()} data-testid="video-submit-button"
          className="flex h-10 items-center justify-center gap-2 rounded-full bg-white px-5 text-sm font-medium text-ink-950 transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:bg-white/10 disabled:text-zinc-500 sm:ml-auto">
          {create.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
          {offer?.available ? `Create · ${formatNumber(offer.credits)} credits` : "Create"}
        </button>
      </div>
      <p className="text-xs text-zinc-500" data-testid="video-note">
        {offer?.available ? "Videos are 5 seconds and can take a few minutes." : "Video creation isn't available yet. Please check back soon."}
      </p>
    </div>
  );
}
